import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
// import MainPage from "../views/mainPage.vue";
import { TabsLayout } from '@/layouts';
import { App } from 'vue';
import { EUserType, useUserStore } from '@/store';

import conversationRoutes from './modules/conversation';
import { showLoading } from '@/utils';

export const tabsRoutes: Array<RouteRecordRaw> = [
  {
    path: 'grass',
    name: 'grass',
    component: () => import('@/views/grass/index.vue'),
    meta: {
      title: '种草',
      keepAlive: true,
    },
  },
  {
    path: 'promotion',
    name: 'promotion',
    component: () => import('@/views/promotion/index.vue'),
    meta: {
      title: '探店',
      keepAlive: true,
    },
  },
  {
    path: 'sell',
    name: 'sell',
    component: () => import('@/views/sell/index.vue'),
    meta: {
      title: '带货',
      keepAlive: true,
    },
  },
  {
    path: 'announcement',
    name: 'announcement',
    component: () => import('@/views/announcement/index.vue'),
    meta: {
      title: '我的通告',
      keepAlive: true,
    },
  },

  {
    path: 'profile',
    name: 'profile',
    component: () => import('@/views/profile/index.vue'),
    meta: {
      title: '我的',
      keepAlive: true,
    },
  },
];

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/grass',
  },
  {
    path: '/',
    component: TabsLayout,
    children: [
      // {
      //   path: "",
      //   redirect: "/grass",
      // },
      ...tabsRoutes,
    ],
  },

  {
    path: '/profile/collections',
    component: () => import('@/views/profile/collections.vue'),
    meta: {
      title: '我的收藏',
    },
  },
  {
    path: '/profile/businessCard/detail',
    component: () => import('@/views/profile/businessCard/detail.vue'),
    meta: {
      title: '我的名片',
    },
  },

  {
    path: '/profile/businessCard',
    component: () => import('@/views/profile/businessCard/index.vue'),
    meta: {
      title: '我的名片',
    },
  },
  {
    path: '/profile/businessCard/addCard',
    component: () => import('@/views/profile/businessCard/addCard.vue'),
    meta: {
      title: '添加名片',
    },
  },
  {
    path: '/profile/businessCard/editCard',
    component: () => import('@/views/profile/businessCard/editCard.vue'),
    meta: {
      title: '添加名片',
    },
  },
  {
    path: '/profile/address',
    component: () => import('@/views/profile/address/index.vue'),
    meta: {
      title: '我的地址',
    },
  },
  {
    path: '/profile/address/detail',
    component: () => import('@/views/profile/address/addressDetail.vue'),
    meta: {
      title: '添加地址',
    },
  },
  {
    path: '/profile/coupon',
    component: () => import('@/views/profile/coupon/index.vue'),
    meta: {
      title: '通告券',
    },
  },
  {
    path: '/profile/followList',
    component: () => import('@/views/profile/followList.vue'),
    meta: {
      title: '关注列表',
    },
  },

  {
    path: '/profile/coupon/record',
    component: () => import('@/views/profile/coupon/record/index.vue'),
    meta: {
      title: '购买记录',
    },
  },
  {
    path: '/profile/coupon/buy',
    component: () => import('@/views/profile/coupon/buy.vue'),
    meta: {
      title: '购买通告券',
    },
  },
  {
    path: '/profile/vip',
    component: () => import('@/views/profile/vip/index.vue'),
    meta: {
      title: 'vip',
    },
  },
  {
    path: '/profile/vip/agreement',
    component: () => import('@/views/profile/documents/index.vue'),
    meta: {
      title: '会员服务协议',
      docType: 'vip',
    },
  },

  {
    path: '/profile/foot-print',
    component: () => import('@/views/profile/foot-print.vue'),
    meta: {
      title: '足迹',
    },
  },

  {
    path: '/profile/tgz/home',
    component: () => import('@/views/profile/tgz/home.vue'),
    meta: {
      title: '通告主主页',
    },
  },
  {
    path: '/profile/tgz/auth',
    component: () => import('@/views/profile/tgz/auth/index.vue'),
    meta: {
      title: '通告主认证',
    },
  },

  {
    path: '/profile/tgz/auth/brand',
    component: () => import('@/views/profile/tgz/auth/brand.vue'),
    meta: {
      title: '通告主认证',
    },
  },
  {
    path: '/profile/tgz/auth/operating',
    component: () => import('@/views/profile/tgz/auth/operating.vue'),
    meta: {
      title: '通告主认证',
    },
  },
  {
    path: '/profile/tgz/auth/e-commerce',
    component: () => import('@/views/profile/tgz/auth/e-commerce.vue'),
    meta: {
      title: '通告主认证',
    },
  },

  {
    path: '/profile/tgz/signUp',
    component: () => import('@/views/announcement/signUp.vue'),
    meta: {
      title: '报名',
    },
  },

  {
    path: '/profile/tgz/auth/pr',
    component: () => import('@/views/profile/tgz/auth/pr.vue'),
    meta: {
      title: '通告主认证',
    },
  },
  {
    path: '/profile/settings/',
    component: () => import('@/views/profile/settings/index.vue'),
    meta: {
      title: '设置',
    },
  },
  {
    path: '/profile/settings/language',
    component: () => import('@/views/profile/settings/language.vue'),
    meta: {
      title: '语言',
    },
  },
  {
    path: '/profile/messages/',
    component: () => import('@/views/profile/messages/index.vue'),
    meta: {
      title: '消息',
    },
  },
  {
    path: '/profile/messages/system',
    component: () => import('@/views/profile/messages/system.vue'),
    meta: {
      title: '系统消息',
    },
  },
  {
    path: '/profile/messages/square',
    component: () => import('@/views/profile/messages/square.vue'),
    meta: {
      title: '达人广场',
    },
  },
  {
    path: '/profile/messages/audit',
    component: () => import('@/views/profile/messages/audit.vue'),
    meta: {
      title: '审核',
    },
  },
  {
    path: '/profile/messages/favorite',
    component: () => import('@/views/profile/messages/favorite.vue'),
    meta: {
      title: '关注收藏',
    },
  },
  {
    path: '/profile/messages/noticeRegistration',
    component: () => import('@/views/profile/messages/noticeRegistration.vue'),
    meta: {
      title: '通告报名',
    },
  },

  {
    path: '/profile/settings/edit-item',
    component: () => import('@/views/profile/settings/edit-item.vue'),
  },
  {
    path: '/profile/settings/address/index',
    component: () => import('@/views/profile/settings/address/index.vue'),
  },
  {
    path: '/profile/settings/address/detail',
    component: () => import('@/views/profile/settings/address/detail.vue'),
  },
  {
    path: '/profile/settings/black-list',
    component: () => import('@/views/profile/settings/black-list.vue'),
  },
  {
    path: '/grass/detail',
    component: () => import('@/views/grass/detail/index.vue'),
    meta: {
      title: '详情',
    },
  },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/shoping',
    component: () => import('@/views/shoping/index.vue'),
    meta: {
      title: '团币商城',
    },
  },
  {
    path: '/shoping/record',
    component: () => import('@/views/shoping/recordList.vue'),
    meta: {
      title: '团币商城',
    },
  },
  {
    path: '/shoping/detail',
    component: () => import('@/views/shoping/detail.vue'),
    meta: {
      title: '兑换详情',
    },
  },
  {
    path: '/wallet',
    component: () => import('@/views/profile/wallet/index.vue'),
    meta: {
      title: '钱包',
    },
  },
  {
    path: '/wallet/recharge',
    component: () => import('@/views/profile/wallet/recharge.vue'),
    meta: {
      title: '充值',
    },
  },
  {
    path: '/wallet/withdrawal',
    component: () => import('@/views/profile/wallet/withdrawal.vue'),
    meta: {
      title: '提现',
    },
  },
  {
    path: '/wallet/payRecord',
    component: () => import('@/views/profile/wallet/payRecord.vue'),
    meta: {
      title: '提现明细',
    },
  },
  {
    path: '/wallet/details',
    component: () => import('@/views/profile/wallet/details.vue'),
    meta: {
      title: '明细',
    },
  },
  {
    path: '/wallet/cardlist',
    component: () => import('@/views/profile/wallet/cardlist.vue'),
    meta: {
      title: '我的银行卡',
    },
  },
  {
    path: '/wallet/addcard',
    component: () => import('@/views/profile/wallet/addcard.vue'),
    meta: {
      title: '添加银行卡',
    },
  },
  {
    path: '/profile/contact',
    component: () => import('@/views/profile/contact/index.vue'),
    meta: {
      title: '联系',
    },
  },
  {
    path: '/profile/guide',
    component: () => import('@/views/profile/documents/index.vue'),
    meta: {
      title: '新人手册',
      docType: 'guide',
    },
  },
  {
    path: '/profile/terms',
    component: () => import('@/views/profile/documents/index.vue'),
    meta: {
      title: '条款规则',
      docType: 'terms',
    },
  },
  {
    path: '/announcement/publish',
    name: 'announcementPublish',
    component: () => import('@/views/announcement/publish.vue'),
    meta: {
      title: '发布通告',
    },
  },
  {
    path: '/announcement/edit',
    name: 'announcementEdit',
    component: () => import('@/views/announcement/edit.vue'),
    meta: {
      title: '发布通告',
    },
  },
  {
    path: '/announcement/detail/:id',
    name: 'announcementDetail',
    component: () => import('@/views/announcement/detail.vue'),
    meta: {
      title: '通告详情',
    },
  },
  {
    path: '/announcement/uploadDraft',
    component: () => import('@/views/announcement/uploadDraft.vue'),
    meta: {
      title: '上传初稿',
    },
  },

  // 消息聊天模块
  ...conversationRoutes,
  {
    path: '/platformLink/:type',
    name: 'platformLink',
    component: () => import('@/views/platformLink/index.vue'),
    meta: {
      title: '平台链接',
    },
  },
  {
    path: '/report/editReport/:id',
    name: 'announcementReport',
    component: () => import('@/views/report/editReport.vue'),
    meta: {
      title: '举报',
    },
  },
  {
    path: '/report/:id',
    name: 'Report',
    component: () => import('@/views/report/reportIndex.vue'),
    meta: {
      title: '报名列表',
    },
  },
  {
    path: '/report/filterReport',
    name: 'filterReport',
    component: () => import('@/views/report/filterReport.vue'),
    meta: {
      title: '筛选博主',
    },
  },
  {
    path: '/report/customerAddress',
    name: 'customerAddress',
    component: () => import('@/views/report/customerAddress.vue'),
    meta: {
      title: '自定义地区',
    },
  },
  {
    path: '/translationNotice',
    name: 'translationNotice',
    component: () => import('@/views/translationNotice/homeIndex.vue'),
    meta: {
      title: '搜索公告',
    },
  },
  {
    path: '/reportSuccess',
    name: 'reportSuccess',
    component: () => import('@/views/report/reportSucess.vue'),
    meta: {
      title: '报名成功',
    },
  },
  {
    path: '/noteLink',
    name: 'noteLink',
    component: () => import('@/views/report/noteLink.vue'),
    meta: {
      title: '提交笔记链接',
    },
  },
  {
    path: '/evaluate',
    name: 'evaluate',
    component: () => import('@/views/evaluate/index.vue'),
    meta: {
      title: '评价',
    },
  },
  {
    path: '/invitationCode',
    name: 'invitationCode',
    component: () => import('@/views/invitationCode/index.vue'),
    meta: {
      title: '邀请码',
    },
  },
];

// let loadingInstance = null;

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export async function setupRouter(app: App) {
  app.use(router);
  // createRouterGuide(router);
  await router.isReady();
}

const needAuthList = ['/announcement'];
router.beforeEach((to, from, next) => {
  const userStore = useUserStore();
  const isLogined =
    !!userStore.user.userId &&
    (userStore.user.type === EUserType.TGZ ||
      userStore.user.type === EUserType.BZ);
  const hasPhone = !!userStore.user.phone;
  if (isLogined) {
    if (to.path === '/login') {
      if (hasPhone) {
        next('/');
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    if (to.path === '/login' || !needAuthList.includes(to.path)) {
      next();
    } else {
      next();
    }
  }
});

router.afterEach((to, from) => {
  // loadingInstance?.close();
  // loadingInstance = null;
});

export default router;
